import { themeAtom } from "../../shared/atoms";
import type { TechFormSectionLoadErrorProps } from "../models/tech-form-page.models";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

export function TechFormSectionLoadError({
  message = "Your saved answers could not be loaded. Retry before editing this section.",
  onRetry,
}: TechFormSectionLoadErrorProps) {
  const theme = useAtomValue(themeAtom);

  return (
    <div
      role="alert"
      className={twMerge(
        "m-4 rounded border p-4",
        theme.home.tailwind.panelBackground,
        theme.home.tailwind.textDefault,
        theme.uwhcAssistant.border,
      )}
    >
      <h2 className="text-lg font-semibold">Unable to load Technical Form data</h2>
      <p className="mt-2">{message}</p>
      <button
        type="button"
        className={twMerge("mt-4 rounded px-4 py-2", theme.uwhcAssistant.sendBg, theme.uwhcAssistant.sendText)}
        onClick={onRetry}
      >
        Retry
      </button>
    </div>
  );
}
